import client from "./api";

const b64ToBytes = (v) => {
  const raw = atob((v + "=".repeat((4 - (v.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export async function currentSub() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  return reg ? reg.pushManager.getSubscription() : null;
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("Is browser me notifications support nahi hai. iPhone pe pehle app ko Home Screen pe add karein.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notifications allow nahi kiye gaye. Phone settings me Fateh FX ke notifications ON karein.");
  const reg = await navigator.serviceWorker.register("/sw.js").then(() => navigator.serviceWorker.ready);
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await client.get("/push/config");
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToBytes(data.public_key) });
  }
  await client.post("/push/subscribe", { subscription: sub.toJSON() });
  return sub;
}

export async function disablePush() {
  const sub = await currentSub();
  if (!sub) return;
  await client.post("/push/unsubscribe", { endpoint: sub.endpoint }).catch(() => {});
  await sub.unsubscribe();
}

export async function relinkPush() {
  if (!pushSupported() || Notification.permission !== "granted") return;
  const sub = await currentSub();
  if (sub) await client.post("/push/subscribe", { subscription: sub.toJSON() }).catch(() => {});
}
